export const Queries = {
    ONBOARDING_PALETTE: 'ONBOARDING_PALETTE',
    UNSPLASH_IMAGES: 'UNSPLASH_IMAGES',
    SAVED_STATE: "SAVED_STATE"
}